import {
    FEATURE_NAME_CLUSTERING,
    FEATURE_NAME_COURSES,
    FEATURE_NAME_MAPANALYSIS
} from "../utils/Constants";

//the gated features for each subscription level
const gatedFeatures = {
    BASIC: [
        /* "Packages",
        "RecurringAppointments",
        "DisableSingleAppointments", */
        "RegionalPricing",
        "ProviderAcceptance",
        "Integrations",
        "PriceByLocation",
        FEATURE_NAME_CLUSTERING,
        FEATURE_NAME_COURSES,
        FEATURE_NAME_MAPANALYSIS
    ]
    //add more subscription levels and their gated features here
};

// Function to check if a feature is gated based on subscription level
function isFeatureGated(subscriptionLevel, featureName) {
    const subscriptionFeatures = gatedFeatures[subscriptionLevel];
    return subscriptionFeatures
        ? subscriptionFeatures.includes(featureName)
        : false;
}

export const isOpenForClusters = (companyId) => {
    if (process.env.REACT_APP_OPENCLUSTER_FOR) {
        if (process.env.REACT_APP_OPENCLUSTER_FOR.includes(companyId))
            return true;
        else return false;
    }
    return true;
};

export const isOpenMapAnalysis = (company) => {
    if (!isFeatureGated(company.subscriptionLevel, FEATURE_NAME_MAPANALYSIS)) {
        return true;
    } else return false;
};

export const companyCanUseCourses = (company) => {
    if (!isFeatureGated(company.subscriptionLevel, FEATURE_NAME_COURSES)) {
        return true;
    } else return false;
};

export default isFeatureGated;
